"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * @class
 * @classdesc This class is only used for repeating a function to itself.
 * ATTENTION! This is a SINGLETON CLASS so it should be accessed as common.Debouncer.[methodName]
 * @constructor
 */
function Debouncer() {
  this.handler = {};
}
/**
 * Rebounce the function passed in the parameters to recall itself after a certain amount of time.
 * @param {String} id The id connected to the function passed
 * @param {Number} timems The time in milliseconds that the function should wait to debounce
 * @param {Function} func The function witch is wished to debounce
 * @param  {...any} params Any parameters that function needs to be passed by
 */


Debouncer.prototype.debounce = function (id, timems, func) {
  for (var _len = arguments.length, params = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    params[_key - 3] = arguments[_key];
  }

  this.clear(id);
  this.handler[id] = setTimeout(function () {
    func.apply(void 0, params);
  }, timems || 600);
};
/**
 * Stops the debounce of the function connected with the passed id
 * @param {String} id The id for the function wich is intended to be stopped
 */


Debouncer.prototype.clear = function (id) {
  var hand = this.handler[id];

  if (hand) {
    clearTimeout(hand);
    this.handler[id] = null;
  }
};

var exp = new Debouncer();
var _default = exp;
exports.default = _default;